// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"09aa3dcc","547":"8d67f85d"}[chunkId] + ".chunk.js";
};